import { useState } from 'react';
import { gifMeme } from '@/mocks/memes';

export default function GifSection() {
  const [sel, setSel] = useState<string | null>(null);
  const current = gifMeme.find((g) => g.id === sel);

  return (
    <section id="gif" className="py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-700">
              <i className="ri-play-circle-line" /> 会动的梗，更上头
            </span>
            <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">吃瓜专用动图专区</h2>
            <p className="mt-3 text-base text-foreground-700">
              静态图不够，还得动起来。眨眼、蹲后续、瞳孔地震、疯狂吃瓜，每张动图都能精准表达你此刻的围观状态。
            </p>
          </div>
          <button
            onClick={() => document.getElementById('library')?.scrollIntoView({ behavior: 'smooth' })}
            className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 hover:bg-background-100"
          >
            返回表情库
          </button>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {gifMeme.map((g) => (
            <button
              key={g.id}
              onClick={() => setSel(g.id)}
              className="group relative overflow-hidden rounded-2xl border border-background-200 bg-background-50"
            >
              <img
                src={g.img}
                alt={`吃瓜动图${g.phrase}`}
                title={`吃瓜动图 ${g.phrase}`}
                className="aspect-square w-full object-cover"
              />
              <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-background-950/60 px-2.5 py-1 text-xs text-background-50">
                <i className="ri-play-mini-fill text-sm" /> GIF
              </span>
              <div className="absolute inset-0 flex items-center justify-center bg-background-950/0 transition-colors group-hover:bg-background-950/20">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 opacity-0 transition-opacity group-hover:opacity-100">
                  <i className="ri-play-fill text-2xl" />
                </span>
              </div>
              <div className="p-3 text-center">
                <p className="text-sm font-medium text-foreground-900">{g.phrase}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      {sel && current && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-background-950/60 p-4"
          onClick={() => setSel(null)}
        >
          <div
            className="w-full max-w-sm overflow-hidden rounded-2xl bg-background-50"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative">
              <img src={current.img} alt={`吃瓜动图${current.phrase}`} className="aspect-square w-full object-cover" />
              <button
                onClick={() => setSel(null)}
                aria-label="关闭预览"
                className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-background-950/60 text-background-50 hover:bg-background-950/80"
              >
                <i className="ri-close-line text-lg" />
              </button>
            </div>
            <div className="p-4 text-center">
              <p className="text-base font-medium text-foreground-900">{current.phrase}</p>
              <p className="mt-1 text-xs text-foreground-500">{current.caption}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}